export default __webpack_public_path__ + "static/char-31-anr-8d5a1b27199352fb46f6b37dcf774671.webp";